import { render, staticRenderFns } from "./viewArtDialog.vue?vue&type=template&id=889e635c&"
import script from "./viewArtDialog.vue?vue&type=script&lang=js&"
export * from "./viewArtDialog.vue?vue&type=script&lang=js&"
import style0 from "./viewArtDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports